import useLanguage from "../../hooks/useLanguage";
import useMediaQuery from "../../hooks/useMediaQuery";
import CommonPage from "../../components/common-page";
import VirtualizedTable from "../../components/virtualTable";
import { tableLayout } from "./tableLayout";
import { Skeleton, IconButton, TextField, InputAdornment } from "@mui/material";

// Icons
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";

const StyledSkeleton = styled(Skeleton)`
  background-color: ${({ theme }) =>
    theme.palette.background.default}21 !important;
`;

const ContentSkeleton = () => {
  const [
    {
      pages: { content: text },
    },
  ] = useLanguage();
  const isMobile = useMediaQuery();

  const tableColumns = tableLayout?.en?.map((column) => column.dataKey);

  const skeletonData = Array(16)
    .fill(null)
    .map((_, index) =>
      tableColumns.reduce((acc, column) => {
        // Checkbox cell can't render a Skeleton — leave the value falsy.
        acc[column] = column === "published" ? false : <Skeleton />;
        acc.disabled = true;
        return acc;
      }, {})
    );

  return (
    <CommonPage
      title={text.title}
      subtitle={text.subtitle}
      maxWidth={false}
      action={{
        label: <StyledSkeleton variant="text" width={isMobile ? 45 : 85} />,
        disabled: true,
        onClick: () => {},
      }}
    >
      <TextField
        name="search"
        fullWidth
        variant="outlined"
        size="small"
        placeholder={text.search.placeholder}
        disabled
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
      <VirtualizedTable
        columns={tableLayout}
        data={skeletonData}
        disableBorder
        actions={[
          <IconButton key="edit" disabled>
            <EditRoundedIcon fontSize="small" />
          </IconButton>,
          <IconButton key="attach" disabled>
            <DownloadRoundedIcon fontSize="small" />
          </IconButton>,
          <IconButton key="delete" disabled>
            <DeleteRoundedIcon fontSize="small" />
          </IconButton>,
        ]}
      />
    </CommonPage>
  );
};

export default ContentSkeleton;
